import React from 'react';

const Policy = () => {
  return (
    <div style={{ fontFamily: 'Arial, sans-serif', maxWidth: '800px', margin: '0 auto', padding: '40px 20px', color: '#333', lineHeight: '1.8' }}>

      <h1 style={{ fontSize: '28px', fontWeight: '700', marginBottom: '8px' }}>Privacy Policy</h1>
      <p style={{ color: '#888', marginBottom: '32px', fontSize: '14px' }}>Last updated: July 7, 2026</p>

      <p style={{ marginBottom: '24px' }}>
        Perfect Layout ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you use our mobile application.
      </p>

      <h2 style={{ fontSize: '18px', fontWeight: '700', marginBottom: '8px', marginTop: '32px' }}>1. Information We Collect</h2>
      <p>We may collect the following information when you use our app:</p>
      <ul style={{ paddingLeft: '20px', marginTop: '8px' }}>
        <li>Name and email address (when you register or contact us)</li>
        <li>Login credentials</li>
        <li>Device information and usage data</li>
        <li>Any information you voluntarily provide</li>
      </ul>

      <h2 style={{ fontSize: '18px', fontWeight: '700', marginBottom: '8px', marginTop: '32px' }}>2. How We Use Your Information</h2>
      <ul style={{ paddingLeft: '20px', marginTop: '8px' }}>
        <li>To operate and maintain the app</li>
        <li>To respond to your requests and support queries</li>
        <li>To send important notifications related to your account</li>
        <li>To improve app features and user experience</li>
        <li>To comply with legal obligations</li>
      </ul>

      <h2 style={{ fontSize: '18px', fontWeight: '700', marginBottom: '8px', marginTop: '32px' }}>3. Sharing of Information</h2>
      <p>
        We do not sell, trade, or share your personal information with third parties except as required by law or with your explicit consent. We only use permissions necessary for app functionality.
      </p>

      <h2 style={{ fontSize: '18px', fontWeight: '700', marginBottom: '8px', marginTop: '32px' }}>4. Data Security</h2>
      <p>
        We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, disclosure, alteration, or destruction.
      </p>

      <h2 style={{ fontSize: '18px', fontWeight: '700', marginBottom: '8px', marginTop: '32px' }}>5. Data Retention</h2>
      <p>
        We retain your personal data only as long as necessary to provide our services or as required by law. You may request deletion of your data at any time by contacting us.
      </p>

      <h2 style={{ fontSize: '18px', fontWeight: '700', marginBottom: '8px', marginTop: '32px' }}>6. Children's Privacy</h2>
      <p>
        Our app is not directed to children under the age of 13. We do not knowingly collect personal information from children. If we become aware that a child has provided us with personal data, we will delete it promptly.
      </p>

      <h2 style={{ fontSize: '18px', fontWeight: '700', marginBottom: '8px', marginTop: '32px' }}>7. Your Rights</h2>
      <p>You have the right to:</p>
      <ul style={{ paddingLeft: '20px', marginTop: '8px' }}>
        <li>Access the personal information we hold about you</li>
        <li>Request correction or deletion of your data</li>
        <li>Withdraw consent at any time</li>
      </ul>

      <h2 style={{ fontSize: '18px', fontWeight: '700', marginBottom: '8px', marginTop: '32px' }}>8. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. We will notify you of any significant changes by updating the date at the top of this page.
      </p>

      <h2 style={{ fontSize: '18px', fontWeight: '700', marginBottom: '8px', marginTop: '32px' }}>9. Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy, please contact us at:
      </p>
      <p style={{ marginTop: '8px' }}>
        <strong>Perfect Layout</strong><br />
        Email: <a href="mailto:care@perfectlayout.in" style={{ color: '#0066cc' }}>care@perfectlayout.in</a>
      </p>

    </div>
  );
};

export default Policy;
